import React, { useState, useEffect, useCallback } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import queryString from "query-string";
import { FormCheck, Tab, Tabs } from "react-bootstrap";
import axiosInstance from "../../utils/axiosInstance";
import Pagination from "../../components/pagination/pagination";
import LoaderComponent from "../../components/Spinner/LoaderComponent";
import ButtonBasic from "../../components/Buttons/ButtonBasic";
import FilterIcon from "../../assets/images/filter.png";
import Filter from "../../components/FilterDropdown/GenericFilter";
import { useDateTime } from "../../components/Helper/DateTime";
import { RetailPOSAccountsMenu } from "./retail-pos-accounts-menu";
import BadgeRounded from "../../components/BadgeRounded/BadgeRounded";
import moment from "moment";

import {
  mapFilters,
  handleFilterChange,
  filtersParams,
  handleNewFilter,
} from "../../utils/filtersHelper";
import RetailPOSModal from "./retail-pos-modal";
import Toast from "../../components/Toast/Toast";
import RetailViewModal from "./retail-pos-view-modal";

const RetailAccounts = (props) => {
  const { currency, setRefresh, date } = useDateTime();
  const [summaryData, setSummaryData] = useState([]);
  const [retailPOSData, setRetailPOSData] = useState([]);
  const [glData, setGLData] = useState([]);
  const [reconciledData, setReconciledData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [sort, setSort] = useState({ sort_by: "", sort_order: "" });
  const [filter, setFilter] = useState({});
  const [filterData, setFilterData] = useState([]);
  const [showFilters, setShowFilters] = useState([]);
  const [tabskey, setTabsKey] = useState("retail");
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const params = queryString.parse(props.location.search);
  const onSortTable = (type, newState) => {
    setPage(1);
    setSort({ sort_by: newState.sortField, sort_order: newState.sortOrder });
  };

  const rowEvent = {
    onClick: (e, row) => {
      setShowViewModal(true);
      // setId(row.id);
    },
  };

  const fetchSummary = useCallback(
    (filter) => {
      if (
        selectedAccount?.reconAccountId !== undefined &&
        selectedAccount?.reconAccountId !== null
      ) {
        setLoading(true);
        let allFilters = filtersParams(filter, null, true);
        let url = `/accounts/summary?${allFilters}&accountIds=${selectedAccount?.reconAccountId},${selectedAccount?.glAccountId}`;
        axiosInstance
          .get(url)
          .then((res) => {
            if (res.message.status !== "200") {
              setSummaryData([]);
              setLoading(false);
            } else {
              setSummaryData(res?.data || []);
              setLoading(false);
            }
          })
          .catch((err) => {
            setSummaryData([]);
            setLoading(false);
          });
      }
    },
    // eslint-disable-next-line
    [page, pageSize, sort, selectedAccount]
  );

  const fetchretailPOSData = useCallback(
    (filter) => {
      if (
        selectedAccount?.reconAccountId !== undefined &&
        selectedAccount?.reconAccountId !== null
      ) {
        setLoading(true);
        let allFilters = filtersParams(filter);
        const order = `&sort_by=${sort.sort_by}&sort_order=${sort.sort_order}`;
        let url = `/nostro/statement/${selectedAccount?.reconAccountId}?page=${
          page - 1
        }&size=${pageSize}${allFilters}${
          sort.sort_by && sort.sort_order ? order : ""
        }`;

        axiosInstance
          .get(url)
          .then((res) => {
            if (res.message.status !== "200") {
              setRetailPOSData([]);
              setTotalElements(0);
              setTotalPages(0);
              setLoading(false);
            } else {
              setRetailPOSData(res?.data?.nostroStatements || []);
              setPage(res?.page?.number + 1 || 1);
              setTotalPages(res?.page?.totalPages || 0);
              setTotalElements(res?.page?.totalElements || 0);
              setLoading(false);
            }
          })
          .catch((err) => {
            setRetailPOSData([]);
            setTotalElements(0);
            setTotalPages(0);
            setLoading(false);
          });
      }
    },
    // eslint-disable-next-line
    [page, pageSize, sort, selectedAccount]
  );

  const fetchGLData = useCallback(
    (filter) => {
      if (
        selectedAccount?.reconAccountId !== undefined &&
        selectedAccount?.reconAccountId !== null
      ) {
        setLoading(true);
        let allFilters = filtersParams(filter);
        const order = `&sort_by=${sort.sort_by}&sort_order=${sort.sort_order}`;
        let url = `/accounts/ledger/${selectedAccount?.glAccountId}?page=${
          page - 1
        }&limit=${pageSize}${allFilters}${
          sort.sort_by && sort.sort_order ? order : ""
        }`;

        axiosInstance
          .get(url)
          .then((res) => {
            if (res.message.status !== "200") {
              setGLData([]);
              setTotalElements(0);
              setTotalPages(0);
              setLoading(false);
            } else {
              setGLData(res?.data?.accountDetail || []);
              setPage(res?.page?.number + 1 || 1);
              setTotalPages(res?.page?.totalPages || 0);
              setTotalElements(res?.page?.totalElements || 0);
              setLoading(false);
            }
          })
          .catch((err) => {
            setGLData([]);
            setTotalElements(0);
            setTotalPages(0);
            setLoading(false);
          });
      }
    },
    // eslint-disable-next-line
    [page, pageSize, sort, selectedAccount]
  );

  const fetchReconcilerData = useCallback(
    (filter) => {
      if (
        selectedAccount?.reconAccountId !== undefined &&
        selectedAccount?.reconAccountId !== null
      ) {
        setLoading(true);
        let allFilters = filtersParams(filter);
        const order = `&sort_by=${sort.sort_by}&sort_order=${sort.sort_order}`;
        let url = `/generic/reconciled?page=${
          page - 1
        }&limit=${pageSize}${allFilters}${
          sort.sort_by && sort.sort_order ? order : ""
        }`;

        axiosInstance
          .get(url)
          .then((res) => {
            if (res.message.status !== "200") {
              setReconciledData([]);
              setTotalElements(0);
              setTotalPages(0);
              setLoading(false);
            } else {
              setReconciledData(res?.data || []);
              setPage(res?.page?.number + 1 || 1);
              setTotalPages(res?.page?.totalPages || 0);
              setTotalElements(res?.page?.totalElements || 0);
              setLoading(false);
            }
          })
          .catch((err) => {
            setGLData([]);
            setTotalElements(0);
            setTotalPages(0);
            setLoading(false);
          });
      }
    },
    // eslint-disable-next-line
    [page, pageSize, sort, selectedAccount]
  );

  const getFilters = useCallback(() => {
    setLoading(true);
    axiosInstance
      .get(`hierarchical/filters?screen_id=nostro_dashboard`)
      .then((res) => {
        if (res.message.status !== "200") {
          setLoading(false);
        } else {
          const filteredFilters = res.data.filters.filter(
            (x) => x.showOnScreen
          );
          const showFiltersData = res.data.filters.filter(
            (x) => !x.showOnScreen
          );
          setShowFilters(showFiltersData);
          setFilterData(filteredFilters);
          const obj = mapFilters(filteredFilters);
          fetchSummary(obj);
          fetchretailPOSData(obj);
          fetchGLData(obj);
          fetchReconcilerData(obj);
          setFilter(obj);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [props.location.state]);

  const formatNumber = (number) => {
    if (isNaN(Number(number))) {
      return number;
    } else {
      number = Number(number);
      return number.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: true,
      });
    }
  };

  const columnsRetail = [
    { hidden: true, dataField: "id", text: "ID" },
    {
      dataField: "date",
      text: "Date",
    },
    {
      dataField: "details",
      text: "Details",
      formatter: (cell) => (cell ? cell : "-"),
    },
    {
      dataField: "entryRef",
      text: "Reference",
      formatter: (cell) => (cell ? cell : "-"),
    },
    {
      dataField: "debit",
      text: "Debit",
      formatter: (cell) =>
        cell ? formatNumber(cell) : cell === null ? "-" : cell,
      align: "right",
      headerAlign: "right",
    },
    {
      dataField: "credit",
      text: "Credit",
      formatter: (cell) =>
        cell ? formatNumber(cell) : cell === null ? "-" : cell,
      align: "right",
      headerAlign: "right",
    },
    {
      dataField: "balance",
      text: "Balance",
      formatter: (cell) =>
        cell ? formatNumber(cell) : cell === null ? "-" : cell,
      align: "right",
      headerAlign: "right",
    },
  ];

  const headers = [
    {
      label: "Date",
      key: "date",
    },
    {
      label: "Details",
      key: "details",
    },
    {
      label: "Reference",
      key: "entryRef",
    },
    {
      label: "Debit",
      key: "debit",
    },
    {
      label: "Credit",
      key: "credit",
    },
    {
      label: "Balance",
      key: "balance",
    },
  ];

  const handleAccountSelection = (account) => {
    setSelectedAccount(account);
  };

  useEffect(() => {
    getFilters();
  }, [getFilters]);

  useEffect(() => {
    if (filterData.length > 0) {
      if (tabskey === "retail") fetchretailPOSData(filter);
      if (tabskey === "retail_gl") fetchGLData(filter);
      if (tabskey === "reconciler-tab") fetchReconcilerData(filter);
    }
    // eslint-disable-next-line
  }, [fetchretailPOSData, fetchGLData, fetchReconcilerData, tabskey]);

  useEffect(() => {
    fetchSummary(filter);
  }, [fetchSummary]);

  useEffect(() => {
    setRefresh(() => () => {
      fetchSummary(filter);
      fetchretailPOSData(filter);
    });
    return () => {
      setRefresh(() => () => {});
    };
    // eslint-disable-next-line
  }, [fetchSummary, fetchretailPOSData, filter]);

  // const combinedData = reconciledData?.flatMap((obj) => {
  //   const combinedDsA = obj.dsA.map((item) => ({ ...item, dsType: "dsA" }));
  //   const combinedDsB = obj.dsB.map((item) => ({ ...item, dsType: "dsB" }));
  //   return [...combinedDsA, ...combinedDsB];
  // });

  // Find the maximum length of dsA and dsB arrays
  let maxDsALength = 0;
  let maxDsBLength = 0;
  reconciledData?.posReconciled?.forEach((item) => {
    maxDsALength = Math.max(maxDsALength, item.dsA.length);
    maxDsBLength = Math.max(maxDsBLength, item.dsB.length);
  });

  const reconcileStatus = (status) => (
    <BadgeRounded
      color={
        status === "MATCHED"
          ? "success"
          : status === "MISSING"
          ? "warning"
          : "danger"
      }
      title={status}
    />
  );

  return (
    <>
      {loading && (
        <div
          className="spinner-center"
          style={{ top: "0%", left: "0%", zIndex: 2000 }}
        >
          <LoaderComponent />
        </div>
      )}

      <div style={{ opacity: !loading ? "1" : "0.07" }}>
        <div className="row">
          <div className={window.innerWidth > 1600 ? "col-2" : "col-3"}>
            <RetailPOSAccountsMenu
              params={params}
              onAccountSelect={handleAccountSelection}
            />
          </div>
          <div className={window.innerWidth > 1600 ? "col-10" : "col-9"}>
            <div className="row align-items-center d-lg-flex">
              {filterData?.map(
                ({
                  filterName,
                  filterType,
                  filterLabel,
                  showOnScreen,
                  filterId,
                }) => (
                  <div
                    className="filter-item mt-2 ml-3 d-flex"
                    // style={{ minWidth: "210px" }}
                    key={filterId}
                  >
                    <Filter
                      title={filterLabel}
                      filterId={filterId}
                      type={filterType}
                      data={filter[filterName]?.data}
                      filter={filter[filterName]?.filter}
                      removable={!showOnScreen}
                      onChange={(e) =>
                        handleFilterChange(e, filterName, filter, setFilter)
                      }
                      onRemove={(e) =>
                        handleNewFilter(
                          e,
                          filterData,
                          showFilters,
                          filter,
                          setFilter,
                          setFilterData
                        )
                      }
                      isSearchable
                    />
                  </div>
                )
              )}
              <div className="col d-flex justify-content-start mt-2">
                <ButtonBasic
                  wrapperClass={"d-flex justify-content-end mr-0"}
                  icon={FilterIcon}
                  title="Filter"
                  onClick={() => {
                    fetchSummary(filter);
                    if (tabskey === "retail") fetchretailPOSData(filter);
                    if (tabskey === "retail_gl") fetchGLData(filter);
                    if (tabskey === "reconciler-tab")
                      fetchReconcilerData(filter);
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-1 mt-3">
                {summaryData?.find((item) => item.accountType === "POS") && (
                  <h6 className="color-gray pt-5 text-left">Retail</h6>
                )}
                {summaryData?.find((item) => item.accountType === "GL") && (
                  <h6
                    className={`color-gray text-left ${
                      summaryData?.length < 2 ? "pt-5" : "pt-3"
                    }`}
                  >
                    GL
                  </h6>
                )}
              </div>
              <div className="col-11">
                <div className="table-responsive">
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th className="custom-bg-light">Account No.</th>
                        <th className="custom-bg-light">Statement No.</th>
                        <th className="custom-bg-light">Currency</th>
                        <th className="custom-bg-light">
                          Opening Balance Date
                        </th>
                        <th className="custom-bg-light">Opening Balance</th>
                        <th className="custom-bg-light">
                          Closing Balance Date
                        </th>
                        <th className="custom-bg-light">Closing Balance</th>
                        <th className="custom-bg-light">Total Transactions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {summaryData
                        ?.filter(
                          (item) =>
                            item.accountId === selectedAccount?.reconAccountId
                        )
                        .map((item) => (
                          <tr key={item.accountId}>
                            <td className="text-center">
                              {item.accountNumber ?? "-"}
                            </td>
                            <td className="text-center">
                              {item.statementNumber ?? "-"}
                            </td>
                            <td className="text-center">
                              {item.currency ?? "-"}
                            </td>
                            <td className="text-center">
                              {item.openingBalanceDate
                                ? moment(item.openingBalanceDate).format(date)
                                : "-"}
                            </td>
                            <td className="text-center">
                              {item.openingBalance
                                ? `${item.currency} ${
                                    item.openingBalance
                                      ? formatNumber(item.openingBalance)
                                      : "-"
                                  }`
                                : "-"}
                            </td>
                            <td className="text-center">
                              {item.closingBalanceDate
                                ? moment(item.closingBalanceDate).format(date)
                                : "-"}
                            </td>
                            <td className="text-center">
                              {item.closingBalance
                                ? `${item.currency} ${
                                    item.closingBalance
                                      ? formatNumber(item.closingBalance)
                                      : "-"
                                  }`
                                : "-"}
                            </td>
                            <td className="text-center">
                              {item.totalTransactions}
                            </td>
                          </tr>
                        ))}

                      {summaryData &&
                        summaryData
                          ?.filter(
                            (item) =>
                              item.accountId === selectedAccount.glAccountId
                          )
                          ?.map((item) => {
                            return (
                              <tr>
                                <td className="text-center">
                                  {item.accountNumber ?? "-"}
                                </td>
                                <td className="text-center">
                                  {item.statementNumber ?? "-"}
                                </td>
                                <td className="text-center">
                                  {item.currency ?? "-"}
                                </td>
                                <td className="text-center">
                                  {item.openingBalanceDate
                                    ? moment(item.openingBalanceDate).format(
                                        date
                                      )
                                    : "-"}
                                </td>
                                <td className="text-center">
                                  {`${item.currency} ${
                                    item.openingBalance
                                      ? formatNumber(item.openingBalance)
                                      : "-"
                                  }`}
                                </td>
                                <td className="text-center">
                                  {item.closingBalanceDate
                                    ? moment(item.closingBalanceDate).format(
                                        date
                                      )
                                    : "-"}
                                </td>
                                <td className="text-center">
                                  {`${item.currency} ${
                                    item.closingBalance
                                      ? formatNumber(item.closingBalance)
                                      : "-"
                                  }`}
                                </td>
                                <td className="text-center">
                                  {item.totalTransactions}
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <Tabs
                  activeKey={tabskey}
                  onSelect={(key) => setTabsKey(key)}
                  defaultActiveKey="retail"
                  id="retail-tab"
                  className="mb-3"
                >
                  <Tab
                    className="mb-sm-2 mb-md-0"
                    eventKey="retail"
                    title="Retail"
                    tabClassName="custom-tab"
                  >
                    <BootstrapTable
                      bordered={false}
                      classes="rs-table table-layout-auto mb-0 table-custom-style"
                      wrapperClasses="overflow-y-auto mb-2 fancy-scroll"
                      keyField="id"
                      bootstrap4={true}
                      remote={{ pagination: true }}
                      data={retailPOSData ?? []}
                      columns={columnsRetail ?? []}
                      onTableChange={onSortTable}
                      noDataIndication="No data found!"
                    />
                    <Pagination
                      setPage={setPage}
                      page={page}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      totalPages={totalPages}
                      showCSV
                      totalElements={totalElements}
                      data={retailPOSData ?? []}
                      CSVHeaders={headers}
                      csvName="Retail Account Data"
                    />
                  </Tab>

                  <Tab
                    className="mb-sm-2 mb-md-0"
                    eventKey="retail_gl"
                    title="GL"
                    tabClassName="custom-tab"
                  >
                    <BootstrapTable
                      bordered={false}
                      classes="rs-table table-layout-auto mb-0 table-custom-style"
                      wrapperClasses="overflow-y-auto mb-2 fancy-scroll"
                      keyField="id"
                      bootstrap4={true}
                      data={glData?.[0]?.accountLedger ?? []}
                      columns={columnsRetail ?? []}
                      noDataIndication="No data found!"
                      remote={{ pagination: true }}
                      onTableChange={onSortTable}
                    />
                    <Pagination
                      setPage={setPage}
                      page={page}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      totalPages={totalPages}
                      showCSV
                      totalElements={totalElements}
                      data={glData?.[0]?.accountLedger ?? []}
                      CSVHeaders={headers}
                      csvName="GL Account Data"
                    />
                  </Tab>

                  <Tab
                    eventKey="reconciler-tab"
                    title="Reconciler"
                    tabClassName="custom-tab"
                  >
                    <div className="row no-gutters justify-content-center align-items-center">
                      {selectedRow ? (
                        selectedRow?.status !== "MATCHED" ? (
                          <div className="offset-9 col-3">
                            <button
                              className="btn btn-info"
                              onClick={() => setShowModal(true)}
                              style={{ marginTop: "-90px" }}
                            >
                              Match With Adjustment
                            </button>
                          </div>
                        ) : (
                          Toast(
                            "Match with Adjustment is only allowed for Un-Matched/Missing Status",
                            "error"
                          )
                        )
                      ) : null}
                      <div className="col-12">
                        <div className="table-responsive fancy-scroll">
                          <table
                            className="table table-dark"
                            style={{ lineHeight: "12px" }}
                          >
                            <thead>
                              <tr>
                                <th colSpan={7}>
                                  <h6 className="text-info text-center">
                                    Retail
                                  </h6>
                                </th>
                                <th colSpan={5}>
                                  <h6 className="text-danger text-center">
                                    GL
                                  </h6>
                                </th>
                              </tr>
                              <tr>
                                <th className="text-info"></th>
                                <th className="text-info">Matched By</th>
                                <th className="text-info">Status</th>
                                <th className="text-info">Date</th>
                                <th className="text-info">Details</th>
                                <th className="text-info">Reference</th>
                                <th className="text-info">Credit</th>
                                <th className="text-info">Debit</th>
                                <th className="text-danger">Date</th>
                                <th className="text-danger">Details</th>
                                <th className="text-danger">Reference</th>
                                <th className="text-danger">Credit</th>
                                <th className="text-danger">Debit</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reconciledData?.posReconciled?.map(
                                (item, index) => {
                                  const maxRows = Math.max(
                                    item.dsA.length,
                                    item.dsB.length
                                  );
                                  return Array.from({ length: maxRows }).map(
                                    (_, i) => {
                                      const dsAItem = item.dsA[i] || {};
                                      const dsBItem = item.dsB[i] || {};
                                      const isChecked =
                                        selectedRow?.dsA[0]?.id === dsAItem?.id;
                                      return (
                                        <tr
                                          key={i}
                                          style={{
                                            backgroundColor:
                                              i % 2 === 0
                                                ? "#f9f9f9"
                                                : "#ffffff",
                                          }}
                                          onClick={() => setShowViewModal(true)}
                                        >
                                          {/* Render matchedBy and status only on the first row of dsA */}
                                          {i === 0 && (
                                            <>
                                              <td
                                                className="text-center"
                                                style={{ paddingBlock: "5px" }}
                                                rowSpan={maxRows}
                                              >
                                                <FormCheck
                                                  type="checkbox"
                                                  onChange={(e) => {
                                                    if (
                                                      selectedRow &&
                                                      selectedRow.dsA[0].id ===
                                                        item.dsA[0].id
                                                    ) {
                                                      setSelectedRow(null);
                                                    } else {
                                                      setSelectedRow(item);
                                                    }
                                                  }}
                                                  checked={isChecked}
                                                />
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{ paddingBlock: "5px" }}
                                                rowSpan={maxRows}
                                              >
                                                {item.matchedBy ?? "-"}
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{ paddingBlock: "5px" }}
                                                rowSpan={maxRows}
                                              >
                                                {/* {item.status ?? "-"} */}
                                                {reconcileStatus(item?.status)}
                                              </td>
                                            </>
                                          )}

                                          <td
                                            className="text-center"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsAItem.date ?? ""}
                                          </td>
                                          <td
                                            className="text-left"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsAItem.details ?? ""}
                                          </td>
                                          <td
                                            className="text-center"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsAItem.entryRef ?? ""}
                                          </td>
                                          <td
                                            className="text-right"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsAItem.credit
                                              ? formatNumber(dsAItem.credit)
                                              : dsAItem.credit === null
                                              ? ""
                                              : dsAItem.credit}
                                          </td>
                                          <td
                                            className="text-right"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsAItem.debit
                                              ? formatNumber(dsAItem.debit)
                                              : dsAItem.debit === null
                                              ? ""
                                              : dsAItem.debit}
                                          </td>

                                          <td
                                            className="text-center"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsBItem.date ?? ""}
                                          </td>
                                          <td
                                            className="text-left"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsBItem.details ?? ""}
                                          </td>
                                          <td
                                            className="text-center"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsBItem.entryRef ?? ""}
                                          </td>
                                          <td
                                            className="text-right"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsBItem.credit
                                              ? formatNumber(dsBItem.credit)
                                              : dsBItem.credit === null
                                              ? ""
                                              : dsBItem.credit}
                                          </td>
                                          <td
                                            className="text-right"
                                            style={{ paddingBlock: "5px" }}
                                          >
                                            {dsBItem.debit
                                              ? formatNumber(dsBItem.debit)
                                              : dsBItem.debit === null
                                              ? ""
                                              : dsBItem.debit}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  );
                                }
                              )}
                            </tbody>
                          </table>
                        </div>
                        <Pagination
                          setPage={setPage}
                          page={page}
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          totalPages={totalPages}
                          totalElements={totalElements}
                          data={reconciledData?.posReconciled || []}
                          CSVHeaders={headers}
                        />
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        {showViewModal && (
          <RetailViewModal
            showModal={showViewModal}
            setShowModal={setShowViewModal}
            selectedRow={selectedRow}
          />
        )}

        {showModal && (
          <RetailPOSModal
            showModal={showModal}
            setShowModal={setShowModal}
            selectedAccount={selectedAccount}
            selectedRow={selectedRow}
            dataSource={{
              batchId: reconciledData?.batchId,
              datasourceA: reconciledData?.datasourceA,
              datasourceAId: reconciledData?.datasourceAId,
              datasourceB: reconciledData?.datasourceB,
              datasourceBId: reconciledData?.datasourceBId,
            }}
            dsaAccount={{
              type: summaryData[0]?.accountType ?? "",
              number: summaryData[0]?.accountNumber ?? "",
            }}
            dsbAccount={{
              type: summaryData[1]?.accountType ?? "",
              number: summaryData[1]?.accountNumber ?? "",
            }}
          />
        )}
      </div>
    </>
  );
};
export default RetailAccounts;
